// Stripe card input should be wrapped in <Elements> element from '@stripe/react-stripe-js'.
// It has a built in validation. Validation technique is different from the regular input validation

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CardNumberElement } from '@stripe/react-stripe-js';

import CardLogoImg from './CardLogoImg';
import { formInputMixin } from 'core/ui/mixins';
import { getStripeInputStyleProps } from 'core/ui/helpers';
import { ERROR_MESSAGES } from 'core/api/constants';
import { InputErrorMessage } from 'core/ui/atoms/InputMessage';
const stripeStyleOptions = getStripeInputStyleProps();

class StripeCardInput extends PureComponent {
  static propTypes = {
    showInvalidState: PropTypes.bool,   // Determines whether the invalid state should be shown
    placeholder: PropTypes.string,
    onReady: PropTypes.func,
  };

  state = {
    cardType: null,
    isValid: false,
    error: '',
  };

  onChange = (cardData) => {
    this.setState({
      cardType: cardData.brand,
      isValid: cardData.complete,
      error: cardData.empty ? ERROR_MESSAGES.required : (cardData.error || {}).message,
    });
  };

  render() {
    const { showInvalidState, placeholder, onReady } = this.props;
    const { cardType, isValid, error } = this.state;
    return (
      <CardInputWrap>
        <CardNumber
          onChange={this.onChange}
          onReady={onReady}
          placeholder={placeholder}
          error={!isValid && showInvalidState}
          options={stripeStyleOptions}
        />
        {cardType && <CardLogoImg brand={cardType} />}
        {!isValid && showInvalidState && (
          <InputErrorMessage>{error}</InputErrorMessage>
        )}
      </CardInputWrap>
    );
  }
}

const CardNumber = styled(({ error, ...rest }) => <CardNumberElement {...rest} />)`
  ${formInputMixin}
`;

const CardInputWrap = styled.div`
  position: relative;
`;

export default StripeCardInput;
